import { useEffect, useState, useContext } from "react";
import AuthContext from "../components/context/AuthContext";
import axios from "axios";

const useAPIGetData = (url = "") => {
  const authCtx = useContext(AuthContext);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Clean up async useEffect flag.
    let isSubscribed = true;

    setLoading(true);
    let authObj = authCtx?.token
      ? { headers: { Authorization: `token ${authCtx?.token}` } }
      : {};
    axios
      .get(url, authObj)
      .then((response) => {
        if (isSubscribed) {
          if (response?.data == null) {
            setData(null);
            setError(response.data);
          } else if (response?.status !== 200) {
            setData(null);
            setError(`Error: ${response.status} ${response?.data}`);
          } else {
            setData(response?.data);
            setError(null);
          }
        }
      })
      .catch((error) => {
        if (isSubscribed) {
          setData(null);
          setError(error?.response?.data ? error.response.data : error);
        }
      })
      .finally(() => isSubscribed && setLoading(false));

    // Cancel subscription to useEffect.
    return () => (isSubscribed = false);
  }, [authCtx.token, url]);
  return { loading, error, data };
};

export default useAPIGetData;
